import type { StrategyPluginKey } from './types';

export interface StrategyPluginDefinition {
  id: StrategyPluginKey;
  label: string;
}

export const STRATEGY_PLUGINS: readonly StrategyPluginDefinition[] = [
  {
    id: 'traderPro17Strategy',
    label: 'Trader Pro 1.7 Strategy',
  },
  {
    id: 'colorProTradingSuiteV31Strategy',
    label: 'ColorPro v3.1 Strategy',
  },
  {
    id: 'openCode5mStrategy',
    label: 'OpenCode 5m Strategy',
  },
] as const;

export const DEFAULT_BOT_STRATEGY_KEY: StrategyPluginKey = 'traderPro17Strategy';

export const BOT_STRATEGY_OPTIONS: readonly StrategyPluginDefinition[] = STRATEGY_PLUGINS;

export function isStrategyPluginKey(value: string): value is StrategyPluginKey {
  return STRATEGY_PLUGINS.some((plugin) => plugin.id === value);
}
